import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div>
      <footer>
        <div className="Bottom">
          <p>Made with ❤️ Raj</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
